import { render, staticRenderFns } from "./Textbox.vue?vue&type=template&id=463349bb&"
import script from "./Textbox.vue?vue&type=script&lang=js&"
export * from "./Textbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports